import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faUser } from '@fortawesome/free-solid-svg-icons';
import { IRoutePermission } from '../../utils/constants/interfaces';
import { useStoreContext } from '../../store/store';
import { ProgressCircle } from '../../components/ui/ProgressCircle/ProgressCircle';
import { useInterval } from '../../utils/hooks';
import { Helpers } from '../../utils/helpers';
import logoImage from '../../assets/images/logo-dark.png';

export const TopNav = (props: {
  logout: (reason?: number | undefined) => void;
  profileMenu: IRoutePermission[];
}) => {
  const { user } = useStoreContext();
  const sessionMaxTime = 60 * 60; //seconds
  const [timeoutPercentage, setTimeoutPercentage] = useState<number>(0);

  const logoutUser = (e: React.SyntheticEvent) => {
    e.preventDefault();
    props.logout();
  };

  const refreshStatus = useCallback(() => {
    const expireTime = user.expiresAt?.getTime() ?? 0;
    const currentTime = Helpers.getUtcDate().getTime();
    if (expireTime < currentTime) {
      setTimeoutPercentage(0);
      return;
    }
    let timePercentage = 100;
    const tokenTimeRemaining = Math.floor((expireTime - currentTime) / 1000);
    if (tokenTimeRemaining > 0) {
      timePercentage = parseFloat(((tokenTimeRemaining / sessionMaxTime) * 100).toFixed(2));
    }
    setTimeoutPercentage(timePercentage);
  }, [sessionMaxTime, user.expiresAt]);

  useEffect(() => {
    refreshStatus();
  }, [refreshStatus, user.expiresAt]);

  useInterval(() => {
    refreshStatus();
  }, 10000);

  return (
    <div className="sticky-navbar">
      <nav className="navbar navbar-expand-lg">
        <div className="container-fluid">
          <Link to="/" className="topNavLogo">
            <img src={logoImage} alt="" />
          </Link>
          <div>
            <ul className="navbar-nav ms-auto mt-lg-0">
              <li className="nav-item dropdown">
                <a
                  title={`Token Expires: ${Helpers.toShortTime(
                    user.expiresAt ?? new Date()
                  )} - Refresh: ${Helpers.toShortTime(user.refreshAt ?? new Date())}`}
                  className="nav-link dropdown-toggle myAccount"
                  id="navbarDropdown"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false">
                  <span className="circle">
                    <ProgressCircle
                      size={38}
                      strokeWidth={2}
                      visible={true}
                      percentage={timeoutPercentage}
                      color="#ffffffaa"
                      trailColor="#ffffff66">
                      <FontAwesomeIcon icon={faUser} />
                    </ProgressCircle>
                  </span>
                </a>
                <div
                  className="dropdown-menu dropdown-menu-end animate slideIn"
                  aria-labelledby="navbarDropdown">
                  {props.profileMenu?.map((item) => {
                    return (
                      <Link to={item.path} key={item.path} className="dropdown-item">
                        {item.iconClass && (
                          <FontAwesomeIcon className="me-2" icon={item.iconClass} />
                        )}
                        {item.text}
                      </Link>
                    );
                  })}
                  <div className="dropdown-divider"></div>
                  <Link to="#" onClick={logoutUser} className="dropdown-item">
                    <FontAwesomeIcon className="me-2" icon={faLock} />
                    Logout
                  </Link>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
};
